import { Subject } from 'rxjs';

const refreshTagGrid = new Subject<boolean>();
const refreshManageTagGrid = new Subject<boolean>();
const refreshSubjectHubGrid = new Subject<boolean>();
const refreshSubjectsInEditReviewPanel = new Subject<boolean>();
const refreshSubjectReviewActivityLogGrid = new Subject<boolean>();
const refreshSubjectObservationsGrid = new Subject<boolean>();

const SubjectMonitoringService = {
    refreshTagGrid: (message: boolean) => {
        refreshTagGrid.next(message);
    },
    onRefreshTagGrid() {
        return refreshTagGrid.asObservable();
    },

    refreshManageTagGrid: (message: boolean) => {
        refreshManageTagGrid.next(message);
    },
    onRefreshManageTagGrid() {
        return refreshManageTagGrid.asObservable();
    },

    refreshSubjectHubGrid: (message: boolean) => {
        refreshSubjectHubGrid.next(message);
    },
    onRefreshSubjectHubGrid() {
        return refreshSubjectHubGrid.asObservable();
    },

    refreshSubjectsInEditReviewPanel() {
        refreshSubjectsInEditReviewPanel.next(true);
    },
    onRefreshSubjectsInEditReviewPanel() {
        return refreshSubjectsInEditReviewPanel.asObservable();
    },

    refreshSubjectReviewActivityLogGrid() {
        refreshSubjectReviewActivityLogGrid.next(true);
    },
    onRefreshSubjectReviewActivityLogGrid() {
        return refreshSubjectReviewActivityLogGrid.asObservable();
    },

    refreshSubjectObservationsGrid() {
        refreshSubjectObservationsGrid.next(true);
    },
    onRefreshSubjectObservationsGrid() {
        return refreshSubjectObservationsGrid.asObservable();
    },
};

export default SubjectMonitoringService;
